import { tv } from 'tailwind-variants';

const statBar = tv({
  slots: {
    root: 'flex items-center gap-[0.68em]',
    label: 'text-[0.68em] text-indigo-300/60 w-[3.9em] uppercase tracking-wide',
    container: 'flex-1 h-[0.55em] bg-game-surface rounded overflow-hidden',
    bar: 'h-full rounded transition-all duration-300',
    value: 'text-[0.68em] text-indigo-200/70 w-[3em] text-right',
  },
  variants: {
    color: {
      health: { bar: 'bg-gradient-to-r from-red-600 to-red-500' },
      hunger: { bar: 'bg-gradient-to-r from-amber-600 to-amber-500' },
      rest: { bar: 'bg-gradient-to-r from-blue-600 to-blue-500' },
      mood: { bar: 'bg-gradient-to-r from-emerald-600 to-emerald-500' },
    },
  },
});

interface StatBarProps {
  label: string;
  value: number;
  max?: number;
  color: 'health' | 'hunger' | 'rest' | 'mood';
}

export const StatBar = ({ label, value, max = 100, color }: StatBarProps) => {
  const percent = (value / max) * 100;
  const displayValue = max === 100 ? `${Math.round(value)}%` : `${Math.round(value)}/${max}`;
  const styles = statBar({ color });

  return (
    <div class={styles.root()}>
      <span class={styles.label()}>{label}</span>
      <div class={styles.container()}>
        <div class={styles.bar()} style={{ width: `${percent}%` }} />
      </div>
      <span class={styles.value()}>{displayValue}</span>
    </div>
  );
};
